import { Div, Line, TableBuilder } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";
import { MoneyListSummary } from "./MoneyListSummary";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";


export class MoneyList extends Div
{
    constructor(order: Order)
    {
        super();

        const mana = order.Steps.Items.flatMap(x => x.Mana).filter(x => x.Amount > 0)

        this.Append(
            new Div("tab-content__title").Text("Podsumowanie"),
            new MoneyListSummary(order).Class("uk-table uk-table-small uk-table-divider uk-table-middle"),
            new Line(),
            new Div("tab-content__title").Text("Zdarzenia"),
            new TableBuilder(mana)
                .AddColumn("Opis", x => x.Description)
                .AddColumn("Kwota", x => x.Amount + " zł")
                .AddColumn("Krok", x => x.Step.GetFullTitle())
                .AddColumn("Data", x => TimeUtils.FormattedDate(x.When))
                .Build()
        );
    }
}

